import { useMutation } from "@tanstack/react-query";
import { useAxios } from "../useAxios"

export const useGetQuestionCountByCategory = () => {
    const axios = useAxios();

    const fetchCount = async (categorieIds: string[]) => {
        const response = await axios.post("/api/questions/count", categorieIds)
        return response.data;
    }

    return useMutation({
        mutationFn: fetchCount,
    })
}